export default __webpack_public_path__ + "static/media/Carga_tus_documentos_V1.c234f4e3.gif";